import React from 'react'
import {Box, Text, HStack, useMultiStyleConfig} from '@chakra-ui/react'
import Countdown from 'react-countdown'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'

const HeroBannerCountDown = ({endingDate, variant = 'default'}) => {
    const styles = useMultiStyleConfig('HeroBannerCountdown', {variant})
    // const now = new Date()
    // const start = new Date(startingDate)
    const end = new Date(endingDate)

    // if (now < start) {
    //     return null
    // }

    const renderer = ({days, hours, minutes, seconds}) => (
        <HStack {...styles.container}>
            <Box {...styles.counterBox}>
                <Box {...styles.time}>
                    <Text {...styles.timeNumber}>{days}</Text>
                </Box>
                <Text {...styles.text}>
                    <FormattedMessage id="hero_banner_countdown.label.days" defaultMessage="Days" />
                </Text>
            </Box>

            <Box {...styles.counterBox}>
                <Box {...styles.time}>
                    <Text {...styles.timeNumber}>{hours}</Text>
                </Box>
                <Text {...styles.text}>
                    <FormattedMessage
                        id="hero_banner_countdown.label.hours"
                        defaultMessage="Hours"
                    />
                </Text>
            </Box>

            <Box {...styles.counterBox}>
                <Box {...styles.time}>
                    <Text {...styles.timeNumber}>{minutes}</Text>
                </Box>
                <Text {...styles.text}>
                    <FormattedMessage
                        id="hero_banner_countdown.label.minutes"
                        defaultMessage="Minutes"
                    />
                </Text>
            </Box>

            <Box {...styles.counterBox}>
                <Box {...styles.time}>
                    <Text {...styles.timeNumber}>{seconds}</Text>
                </Box>
                <Text {...styles.text}>
                    <FormattedMessage
                        id="hero_banner_countdown.label.seconds"
                        defaultMessage="Seconds"
                    />
                </Text>
            </Box>
        </HStack>
    )

    return <Countdown date={end} renderer={renderer} />
}

HeroBannerCountDown.propTypes = {
    // startingDate: PropTypes.string,
    endingDate: PropTypes.string,
    variant: PropTypes.string,
}

export default HeroBannerCountDown
